import Auth from './auth/authVuex'

import App from './AppVuex'

import BusinessArea from './businessArea/BusinessAreaVuex'
import Systems from './systems/SystemsVuex'
import Modules from './modules/ModulesVuex'
import Module from './module/ModuleVuex'

export default {
  Auth,
  App,

  BusinessArea,
  Systems,
  Modules,
  Module
}



// WEBPACK FOOTER //
// ./src/app/vuex.js